import { Box, Skeleton } from '@mui/material';
import { FC, memo } from 'react';

export const OverviewViewSkeleton: FC = memo(() => (
  <Box sx={{ margin: '20px 0', display: 'flex', flexDirection: 'row', width: '100%' }}>
    <Box sx={{ width: '100%', marginRight: '16px' }}>
      <Skeleton variant="rounded" height={420} />
      <Skeleton variant="rounded" height={200} sx={{ marginTop: '16px' }} />
    </Box>
    <Box sx={{ width: '328px', marginLeft: 'auto', flexShrink: '0' }}>
      <Skeleton variant="rounded" height={50} />
      <Skeleton variant="rounded" height={270} sx={{ marginTop: '16px' }} />
      <Skeleton variant="rounded" height={350} sx={{ marginTop: '16px' }} />
    </Box>
  </Box>
));
